@if (layoutType === layoutTypes.verticalSeperator) {
  <p-divider layout="vertical"></p-divider>
}
